/** Catálogo CIE-10 usado por Donna (odontología y hallazgos del examen estomatognático). */
export const CIE10: Readonly<Record<string, string>> = Object.freeze({
  "B00.1": "Dermatitis vesicular por herpes simple (herpes labial)",
  "A69.1": "Otras infecciones de Vincent (gingivitis o periodontitis ulcerativa necrosante)",
  "B37.0": "Estomatitis candidiásica",
  "J02.9": "Faringitis aguda, no especificada",
  "J03.9": "Amigdalitis aguda, no especificada",
  "J35.1": "Hipertrofia de las amígdalas",
  "K00.0": "Anodoncia",
  "K00.1": "Dientes supernumerarios",
  "K00.2": "Anomalías del tamaño y de la forma del diente",
  "K00.3": "Dientes moteados (fluorosis)",
  "K00.4": "Alteraciones en la formación dentaria (hipoplasia)",
  "K00.5": "Alteraciones hereditarias de la estructura dentaria",
  "K00.6": "Alteraciones en la erupción dentaria",
  "K01.0": "Dientes incluidos",
  "K01.1": "Dientes impactados",
  "K02.0": "Caries limitada al esmalte",
  "K02.1": "Caries de la dentina",
  "K02.2": "Caries del cemento",
  "K02.3": "Caries dentaria detenida",
  "K02.4": "Odontoclasia",
  "K02.9": "Caries dental, no especificada",
  "K03.0": "Atrición excesiva de los dientes",
  "K03.1": "Abrasión de los dientes",
  "K03.2": "Erosión de los dientes",
  "K03.3": "Reabsorción patológica de los dientes",
  "K03.6": "Depósitos [acreciones] en los dientes",
  "K03.7": "Cambios posteruptivos del color de los tejidos duros",
  "K04.0": "Pulpitis",
  "K04.1": "Necrosis de la pulpa",
  "K04.2": "Degeneración de la pulpa",
  "K04.3": "Formación anormal de tejido duro en la pulpa",
  "K04.4": "Periodontitis apical aguda originada en la pulpa",
  "K04.5": "Periodontitis apical crónica",
  "K04.6": "Absceso periapical con fístula",
  "K04.7": "Absceso periapical sin fístula",
  "K04.8": "Quiste radicular",
  "K05.0": "Gingivitis aguda",
  "K05.1": "Gingivitis crónica",
  "K05.2": "Periodontitis aguda",
  "K05.3": "Periodontitis crónica",
  "K05.4": "Periodontosis",
  "K05.5": "Otras enfermedades periodontales",
  "K05.6": "Enfermedad periodontal, no especificada",
  "K06.0": "Retracción gingival",
  "K06.1": "Hiperplasia gingival",
  "K07.3": "Anomalías de la posición del diente",
  "K07.6": "Trastornos de la articulación temporomaxilar",
  "K08.1": "Pérdida de dientes debida a accidente, extracción o enfermedad periodontal local",
  "K08.2": "Atrofia del reborde alveolar desdentado",
  "K08.3": "Raíz dental retenida",
  "K09.2": "Otros quistes de los maxilares",
  "K10.0": "Trastornos del desarrollo de los maxilares",
  "K10.2": "Afecciones inflamatorias de los maxilares",
  "K10.3": "Alveolitis del maxilar",
  "K11.1": "Hipertrofia de glándula salival",
  "K11.2": "Sialoadenitis",
  "K11.5": "Sialolitiasis",
  "K11.6": "Mucocele de glándula salival",
  "K12.0": "Estomatitis aftosa recurrente",
  "K13.0": "Enfermedades de los labios",
  "K13.1": "Mordedura del labio y de la mejilla",
  "K13.2": "Leucoplasia y otras alteraciones del epitelio bucal",
  "K13.4": "Granuloma y lesiones semejantes de la mucosa bucal",
  "K14.0": "Glositis",
  "K14.1": "Lengua geográfica",
  "K14.3": "Hipertrofia de las papilas linguales",
  "K14.5": "Lengua plegada",
  "L03.2": "Celulitis de la cara",
  "L04.0": "Linfadenitis aguda de cara, cabeza y cuello",
  "L43.9": "Liquen plano, no especificado",
  "Q35.9": "Fisura del paladar, sin otra especificación",
  "Q38.1": "Anquiloglosia",
  "R22.0": "Tumefacción, masa o prominencia localizada en la cabeza",
  "R59.0": "Adenomegalia localizada",
  "R68.2": "Sequedad de la boca, no especificada",
  "S02.5": "Fractura de los dientes",
  "S03.2": "Luxación de diente"
});

export function descripcionCie(codigo: string | null | undefined): string {
  return codigo ? (CIE10[codigo] ?? "") : "";
}

/* ---------- búsqueda por palabras clave ---------- */

/** Palabras con que se suele nombrar cada diagnóstico en la consulta (sin tildes; se buscan por palabra o comienzo). */
const CLAVES_CIE10: Readonly<Record<string, string>> = {
  "B00.1": "herpes fuego fuegos labial ampollas",
  "A69.1": "gingivitis ulcerativa necrosante necrotizante periodontitis necrosante vincent gus pus ulceras encia dolor papilas",
  "B37.0": "candidiasis hongos muguet algodoncillo placas blancas",
  "J02.9": "faringitis garganta",
  "J03.9": "amigdalitis anginas",
  "K00.0": "anodoncia agenesia falta congenita no se formo",
  "K00.1": "supernumerario mesiodens diente extra",
  "K00.2": "microdoncia macrodoncia conoide forma tamano",
  "K00.3": "fluorosis manchas blancas moteado",
  "K00.4": "hipoplasia hipomineralizacion mih esmalte defectuoso",
  "K00.5": "amelogenesis dentinogenesis imperfecta hereditaria",
  "K00.6": "erupcion retraso persistencia temporal diente de leche retenido",
  "K01.0": "incluido retenido canino incluido",
  "K01.1": "impactado muela del juicio cordal tercer molar semiretenido",
  "K02.0": "caries incipiente esmalte mancha blanca desmineralizacion inicial",
  "K02.1": "caries dentina profunda media cavidad hueco picado muela picada",
  "K02.2": "caries radicular raiz cuello cervical",
  "K02.3": "caries detenida inactiva",
  "K02.9": "caries",
  "K03.0": "desgaste atricion bruxismo rechinar facetas",
  "K03.1": "abrasion cepillado abfraccion lesion cervical cuna",
  "K03.2": "erosion acido reflujo bebidas gaseosas",
  "K03.3": "reabsorcion radicular interna externa",
  "K03.6": "sarro calculo tartaro placa bacteriana pigmentacion manchas cafe",
  "K03.7": "cambio de color diente oscuro gris tincion decoloracion",
  "K04.0": "pulpitis dolor espontaneo dolor al frio dolor nocturno sensibilidad reversible irreversible nervio inflamado",
  "K04.1": "necrosis necrotica diente muerto nervio muerto sin vitalidad desvitalizado",
  "K04.2": "degeneracion pulpar",
  "K04.3": "calcificacion pulpolito conducto calcificado obliterado",
  "K04.4": "periodontitis apical aguda dolor a la percusion dolor al morder",
  "K04.5": "periodontitis apical cronica lesion periapical granuloma radiolucidez",
  "K04.6": "absceso con fistula fistula pus drenaje",
  "K04.7": "absceso sin fistula flemon hinchazon inflamacion infeccion pus",
  "K04.8": "quiste radicular periapical",
  "K05.0": "gingivitis aguda encias inflamadas sangrado",
  "K05.1": "gingivitis cronica sangrado de encias encias rojas inflamacion gingival",
  "K05.2": "periodontitis aguda absceso periodontal",
  "K05.3": "periodontitis cronica piorrea bolsas movilidad perdida osea dientes flojos enfermedad periodontal",
  "K05.4": "periodontosis",
  "K05.5": "otras enfermedades periodontales periodontitis sistemica lesion endoperiodontal endo periodontal",
  "K05.6": "enfermedad periodontal sin especificar periodontitis sin especificar",
  "K06.0": "recesion retraccion encia retraida raiz expuesta",
  "K06.1": "hiperplasia gingival agrandamiento encia crecida",
  "K07.3": "apinamiento malposicion diente torcido rotado diastema maloclusion ortodoncia",
  "K07.6": "atm articulacion mandibula chasquido bloqueo dolor articular",
  "K08.1": "perdida ausente falta diente edentulo desdentado extraido espacio implante",
  "K08.2": "atrofia reborde hueso insuficiente reabsorcion osea",
  "K08.3": "raiz retenida resto radicular resto de raiz",
  "K09.2": "quiste maxilar",
  "K10.0": "maxilares desarrollo",
  "K10.2": "osteitis osteomielitis maxilar inflamacion",
  "K10.3": "alveolitis alveolo seco dolor post extraccion",
  "K11.1": "glandula salival hipertrofia",
  "K11.2": "sialoadenitis parotiditis glandula inflamada",
  "K11.5": "sialolitiasis calculo salival",
  "K11.6": "mucocele bolita labio",
  "K12.0": "afta aftas llaga ulcera",
  "K13.0": "queilitis labios agrietados",
  "K13.1": "mordedura mejilla labio",
  "K13.2": "leucoplasia placa blanca",
  "K13.4": "granuloma piogenico epulis",
  "K14.0": "glositis lengua inflamada",
  "K14.1": "lengua geografica",
  "K14.3": "papilas linguales",
  "K14.5": "lengua fisurada plegada",
  "L03.2": "celulitis cara hinchada infeccion facial",
  "L04.0": "ganglios linfadenitis",
  "L43.9": "liquen plano",
  "Q35.9": "fisura paladar hendido",
  "Q38.1": "anquiloglosia frenillo lengua amarrada",
  "R22.0": "tumefaccion masa bulto",
  "R59.0": "adenomegalia ganglios inflamados",
  "R68.2": "boca seca xerostomia",
  "S02.5": "fractura diente roto fisura astillado golpe trauma traumatismo",
  "S03.2": "luxacion avulsion diente movido golpe trauma",
};

const sinTilde = (t: string) => t.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const VACIAS = new Set(["de", "del", "la", "el", "los", "las", "en", "con", "por", "y", "a", "al", "un", "una", "sin"]);
const palabras = (t: string) => sinTilde(t).split(/[^a-z0-9.]+/).filter((x) => x.length > 1 && !VACIAS.has(x));
const INDICE = Object.entries(CIE10).map(([codigo, desc]) => {
  const claves = CLAVES_CIE10[codigo] ?? "";
  return { codigo, desc, texto: ` ${sinTilde(`${desc} ${claves}`)} `, lista: palabras(`${desc} ${claves}`), cod: codigo.toLowerCase().replace(".", "") };
});

export interface ResultadoCie { codigo: string; descripcion: string }

/**
 * Busca diagnósticos CIE-10 por código («K04», «k041») o por palabras de la consulta («absceso», «muela del juicio»,
 * «sangrado encias»). Todas las palabras deben coincidir; primero lo más parecido.
 */
export function buscarCie10(consulta: string, max = 8): ResultadoCie[] {
  const q = sinTilde(consulta).trim();
  if (!q) return [];
  const cod = q.replace(/[\s.]/g, "");
  const tokens = palabras(q);
  const res: { codigo: string; desc: string; puntos: number }[] = [];
  for (const x of INDICE) {
    let puntos = 0;
    if (/^[a-z]\d/.test(cod) && x.cod.startsWith(cod)) puntos += 100 - (x.cod.length - cod.length);
    else {
      if (!tokens.length) continue;
      let todas = true;
      for (const t of tokens) {
        if (x.lista.includes(t)) puntos += 10;
        else if (x.lista.some((w) => w.startsWith(t))) puntos += 6;
        else if (t.length >= 4 && x.texto.includes(t)) puntos += 3;
        else { todas = false; break; }
      }
      if (!todas) continue;
      if (tokens.length > 1 && x.texto.includes(` ${tokens.join(" ")}`)) puntos += 8;   // la frase completa
      if (sinTilde(x.desc).startsWith(tokens[0])) puntos += 4;                          // empieza por la palabra
    }
    res.push({ codigo: x.codigo, desc: x.desc, puntos });
  }
  return res.sort((a, b) => b.puntos - a.puntos || a.codigo.localeCompare(b.codigo)).slice(0, max).map((x) => ({ codigo: x.codigo, descripcion: x.desc }));
}

/** Diagnósticos más usados para cada tipo de hallazgo del odontograma (para elegir con un toque). */
export const CIE_POR_HALLAZGO: Readonly<Record<string, readonly string[]>> = {
  caries: ["K02.0", "K02.1", "K02.2", "K02.9"],
  obturacion: ["K02.1", "K02.9"],
  sellante: ["K02.0"], fluor: ["K02.0", "K00.4"],
  ausente: ["K08.1"], perdida_otra: ["K08.1", "S03.2"],
  extraccion: ["K08.3", "K04.7", "K01.1", "K05.3"],
  endodoncia: ["K04.0", "K04.1", "K04.5", "K04.7"],
  pulpotomia: ["K04.0"], pulpectomia: ["K04.0", "K04.1"],
  fractura: ["S02.5"], corona: ["K02.1", "S02.5", "K03.0"], incrustacion: ["K02.1"], carilla: ["K03.7", "K00.3", "K07.3"], perno: ["S02.5", "K02.1"],
  implante: ["K08.1", "K08.2"], puente: ["K08.1"], removible: ["K08.1"], protesis_total: ["K08.1"],
  movilidad: ["K05.3", "S03.2"], recesion: ["K06.0"], erupcion: ["K00.6", "K01.1"], mantenedor: ["K08.1"],
  incluido: ["K01.1"], supernumerario: ["K00.1"], quiste: ["K04.8"], apicectomia: ["K04.5", "K04.8"], traccion: ["K01.1"], frenectomia: ["Q38.1"],
  diagnostico: ["K03.6", "K04.0", "K05.1", "K05.3", "K02.1"],
};
